<template>
  <div id="Q2" class="sub">
    <div class="wrapper">
      <kg-header :headerType="Number(headerType)"/>
      <div id="content">
        <div class="inner_static">
          <h1 class="tit1">お問い合わせ</h1>
          <div class="vm_wrap">
            <div class="inner_static">
              <h2 class="ins_tit type2">お問い合わせの送信が完了しました。</h2>
              <p class="ins_lead type3">
                担当者からご登録いただいたメールアドレス宛にメールで回答させていただきます。
              </p>
            </div>
          </div>
          <div class="fixed_btn_area">
            <div class="inner_static">
              <a class="btn1" @click="btnTopClick()">TOPへ</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'

// kaggul Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header
  },
  props: {
    headerType: {
      type: String,
      default: '0'
    }
  },
  methods: {
    btnTopClick: function () {
      if (this.headerType === '0') {
        this.$router.push('/kagull/login')
      } else {
        this.$router.push('/kagull/top')
      }
    }
  },
  created: function () {
    App.removeLocalStorage(KG_STORAGE_KEY.CONTACT_DATA)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/ContactComplete.vue